<template>
    <section id="result-search-page">
        <div :class="containerClasses">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>
                                {{title}}
                            </h2>
                        </div>
                        <div class="right">
                            <template v-if="vehicleIds.length">
                                <a v-if="canCopyFavouriteList" @click="copyFavListModelOpen = true" class="btn">Copy Favourites</a>
                                <a href="#" @click="emailModelOpen = true" class="btn">Send Email</a>
                                <a v-if="$userIsAdmin()" @click="sendRecommend()" class="btn">Send Recommend</a>
                            </template>
                        </div>
                    </div>
                    <div class="bottom">
                        <span class="showing">
                            <strong>Showing</strong>
                            <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                            results
                        </span>
                        <div class="view-type-selection">
                            <label for="view-grid" :class="viewType === 'grid' ? 'active' : ''">
                                <input id="view-grid" type="radio" value="grid" v-model="viewType"/>
                                <icon icon=" fa-lg fa-th"></icon>
                            </label>
                            <label for="view-list" :class="viewType === 'list' ? 'active' : ''">
                                <input id="view-list" type="radio" value="list" v-model="viewType"/>
                                <icon icon=" fa-lg fa-list"></icon>
                            </label>
                        </div>
                        <select class="per-row" v-model="perRow">
                            <option v-for="option in vehicles_in_row_options" :value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <user-selector
                                v-if="$userCan('administrate')"
                                v-model="userFilter"
                                @change="onUserChange"
                                class="select-all"
                        >
                        </user-selector>

                        <RecentDatesSelector :showAll="false" class="select-all" v-model="selectedAuctionDate" @change="onDateChange"/>
                        <select name="sorting" id="sorting" v-model="sortByModel" @change="onSortChange" class="select-all ml-0 ml-lg-auto">
                            <option value="">-</option>
                            <option v-for="(data, value) of order_options" :value="value">
                                {{data.text}}
                            </option>
                        </select>
                        <div class="large-space">
                            <b-form-radio-group  v-model="favouriteListForFilter" @change="onFavFilter">
                                <b-form-radio :value="null">All favourites</b-form-radio>
                                <template v-for="fav in favouriteLists">
                                    <b-form-radio :value="fav.value">
                                        {{fav.text}}
                                    </b-form-radio>
                                </template>
                            </b-form-radio-group>
                        </div>
                    </div>
                </div>
                <div class="container-table">
                    <div class="list-table table-responsive" v-if="viewType === 'list'">
                        <b-table
                            class="list-table"
                            :sort-by.sync="sort_by"
                            :sort-desc.sync="sort_desc"
                            @sort-changed="onChange"
                            :fields="fields"
                            :items="favourites"
                            :no-local-sorting="true"
                            show-empty
                        >
                            <template v-slot:empty="scope">
                                <template v-if="loading">
                                    Loading...
                                </template>
                                <template v-else>
                                    No data is available...
                                </template>
                            </template>
                            <template v-slot:cell(vehicle)="data">
                                <a :href="getVehicleLink(data.item)">
                                    <img :src="data.item.front_image_url" alt="Front"
                                         v-if="data.item.front_image_url" height="50">
                                </a>
                            </template>
                            <template v-slot:cell(mileage)="data">
                                {{ numberWithCommas(data.item.mileage) }}
                            </template>
                            <template v-slot:cell(auction_date)="data">
                                <div class="time" :title="getJapanDiff(data.item.auction_date)">
                                    {{ getDateTime(data.item.auction_date).format('h:mma') }} JPN /
                                    {{ getNZDateTime(data.item.auction_date).format('h:mma') }} NZ
                                </div>
                            </template>
                            <template v-slot:cell(stock_id)="data">
                                <template v-if="data.item.sold && data.item.sold.heiwa_stock_id && !data.item.stock_id">
                                    {{data.item.sold.heiwa_stock_id}}
                                </template>
                                <template v-else>
                                    {{data.item.stock_id}}
                                </template>
                            </template>
                            <template v-slot:cell(actions)="data">
                                <a :href="getVehicleLink(data.item)">View</a>
                            </template>
                        </b-table>
                    </div>
                    <div class="container-results" id="container-results" v-else>
                        <template v-if="favourites && favourites.length">
                            <Vehicle v-for="vehicle of favourites" :key="vehicle.id"
                                     :vehicle="vehicle"
                                     :selected="selectedVehicles.indexOf(vehicle.api_id) !== -1"
                                     priceField="start_price"
                                     @tagPopupModal="tagPopupModal">
                            </Vehicle>
                        </template>
                        <template v-else>
                            <template v-if="loading">
                                Loading...
                            </template>
                            <template v-else>
                                No favourites found.
                            </template>
                        </template>
                        <div class="single-result-search none" v-for="vehicle of [1,2,3,4,5,6,7,8]"></div>
                    </div>
                </div>
                <div class="bottom-container-result d-flex justify-content-end flex-wrap">
                    <div class="d-flex justify-content-end">
                        <b-pagination
                                v-if="total > 0"
                                :total-rows="total"
                                :per-page="per_page"
                                v-model="current_page"
                        ></b-pagination>
                    </div>
                </div>
            </div>
            <a v-if="vehicleIds.length" href="#" @click="emailModelOpen = true" class="btn">Send Email</a>
            <a v-if="$userIsAdmin()" @click="sendRecommend()" class="btn">Send Recommend</a>
            <a v-if="vehicleIds.length && $userIsAdmin()" @click="recommendModelOpen = true" class="btn pull-right">Recommend</a>
        </div>

        <vehicle-recommendation-modal :notifyMessage="recommendMessageSendEmail" v-if="vehicleIds.length" :selectedVehicles="vehicleIds" v-model="recommendModelOpen" :recommend="true"></vehicle-recommendation-modal>
        <vehicle-recommendation-modal :notifyMessage="notifyMessageSendEmail" :selectedVehicles="vehicleIds" v-model="emailModelOpen" :recommend="false"></vehicle-recommendation-modal>
        <favourite-tag-modal
                :vehicleId=selectedVehicleId
                v-model="favListModalOpen"
                @changed="onTagChanged"
        ></favourite-tag-modal>
        <CopyFavListModal
            v-model="copyFavListModelOpen"
            :selectedListId="favouriteListForFilter"
            :userFilter="userFilter"
            :selectedAuctionDate="selectedAuctionDate"
        />
    </section>
</template>
<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    import moment from 'moment'
    import Vehicle from '../Common/Vehicle';
    import CopyFavListModal from '../CopyFavListModal.vue';
    import {
        numberWithCommas,
        objLookup,
        getDateTime,
        getNZDateTime,
        getJapanDiff,
        addPageUrlParam
    } from '../../util/common'
    import RecentDatesSelector from '../Common/RecentDatesSelector'
    import UserSelector from '../Common/UserSelector'
    import {getterSetter} from "../../util/vuex_setter_getter";
    export default {
        components: {
            RecentDatesSelector,
            UserSelector,
            Vehicle,
            CopyFavListModal
        },
        props: [
            'favouriteListId'
        ],
        created() {
            if (this.$route.query && this.$route.query.user_id) {
                this.userFilter = parseInt(this.$route.query.user_id)
            }
            if (this.$route.query && this.$route.query.date) {
                this.selectedAuctionDate = this.$route.query.date
            }
            if (this.$route.query && this.$route.query.tag_id) {
                this.favouriteListForFilter = this.$route.query.tag_id
            }
            if (this.$route.query && this.$route.query.sort_by) {
                let value = this.$route.query.sort_by;
                if (this.order_options[value]) {
                    this.sortByModel = value
                    this.sort_by = this.order_options[value].field;
                    this.sort_desc = this.order_options[value].order_desc;
                }
            }
            this.getData();
            this.$store.dispatch('stock_nextprev/checkStack');
        },
        mounted() {
            if (!this.$route.query.page) {
                addPageUrlParam(this.current_page, this.$router, true)
            }
            this.$nextTick(() => {
                this.$store.dispatch('auction_nextprev/checkListReturn', this.$route.query.state_key || null)
            });
        },
        data() {
            return {
                notifyMessageSendEmail: 'We’ve hand-picked some vehicles in the upcoming auctions that may work for you. Get in touch with me for more information on any of these vehicles',
                emailModelOpen: false,
                recommendMessageSendEmail: 'We’ve hand-picked some vehicles in the upcoming auctions that may work for you. Get in touch with me for more information on any of these vehicles.',
                sort_by: 'make',
                sort_desc: false,
                loading: false,
                recommendModelOpen: false,
                sortByModel: 'make',
                selected_search: null,
                copyFavListModelOpen: false,
                vehicleIds: [],
                selectedfavouriteList: null,
                favouriteListForFilter: this.favouriteListId || null,
                boxLeft: false,
                userFilter: this.loggedInUser.id,
                hoveredImageVehicleId: null,
                hoveredImageType: null,
                favListModalOpen: false,
                selectedVehicleId: '',
                users: [],
                viewType: 'grid',
                perPage: 2000,
                perRow: 5,
                vehicles_in_row_options: [
                    {value: 0, text: 'FULL WIDTH'},
                    {value: 5, text: '5 per row'},
                    {value: 6, text: '6 per row'},
                ],
                fields: [
                    {label: 'Image', key: 'vehicle'},
                    {label: 'Make', key: 'make',sortable: true},
                    {label: 'Model', key: 'model', sortable: true},
                    {label: 'Grade', key: 'grade', sortable: true},
                    {label: 'Chassis', key: 'chassis', sortable: true},
                    {label: 'Year', key: 'year', sortable: true},
                    {label: 'Mileage', key: 'mileage', sortable: true},
                    {label: 'Colour', key: 'color', sortable: true},
                    {label: 'CC', key: 'engine_capacity', sortable: true},
                    {label: 'Trans', key: 'transmission', sortable: true},
                    {label: 'Fuel', key: 'fuel_type', sortable: true},
                    {label: 'Cnd', key: 'condition', sortable: true},
                    {label: 'Equip', key: 'equipment',sortable: true},
                    {label: 'Price', key: 'start_price',sortable: true},
                    {label: 'Time', key: 'auction_date',sortable: true},
                ],
                order_options: {
                    created_at: {text: 'Most recent', field: 'created_at', order_desc: true},
                    make: {text: 'Make', field: 'make', order_desc: false},
                    model: {text: 'Model', field: 'model', order_desc: false},
                    auction_date: {text: 'Auction time', field: 'auction_date', order_desc: false},
                },
                selectedAuctionDate: moment().format('YYYY-MM-DD'),
            }
        },
        computed: {
            ...mapState({
                favouriteLists: state => state.favourites.favourite_lists,
                per_page: state => state.favourites.per_page,
                from: state => state.favourites.from,
                to: state => state.favourites.to,
                last_page: state => state.favourites.last_page,
                total: state => state.favourites.total,
            }),
            favourites: {
                get(){
                    const url_state_key = this.$route.query && this.$route.query.state_key ? this.$route.query.state_key : null;
                    if (url_state_key && this.$store.getters['favourites/getLastStateKey'] === url_state_key) {
                        return this.$store.getters['favourites/all']
                    }
                    const state_key = window.history.state && window.history.state.key ? window.history.state.key : null;
                    if (state_key && this.$store.getters['favourites/getLastStateKey'] === state_key) {
                        return this.$store.getters['favourites/all']
                    }
                    return []
                }
            },
            selectedVehicles: new getterSetter('auction_search/getSelectedVehicles', 'auction_search/setSelectedVehicles'),
            title(){
                let title = false
                if (this.userFilter !== this.loggedInUser.id && this.users) {
                    this.users.forEach(u => {
                        if (u.id === this.userFilter) {
                            title = `${u.name} favourites`
                        }
                    })
                    if (title === false) {
                        title = 'Favourites'
                    }
                }
                if (title === false) {
                    title = 'My favourites'
                }
                return title
            },
            containerClasses(){
                let classes = ['container'];
                if (this.perRow === 0) {
                    classes.push('full-width');
                } else if (this.perRow === 5) {
                    classes.push('per-5');
                } else if (this.perRow === 6) {
                    classes.push('per-6');
                }
                return classes.join(' ');
            },
            current_page: {
                get() {
                    let page = this.$store.getters['favourites/current_page'];
                    return page || 1;
                },
                set(value) {
                    this.setCurrentPage(value)
                    addPageUrlParam(value, this.$router)
                    this.getData()
                }
            },
            canCopyFavouriteList(){
                return this.$userIsAdmin() && this.userFilter !== this.loggedInUser.id
            },

            favouriteListsSelect() {
                return this.favouriteLists.map(function (favouriteList) {
                    return {
                        value: favouriteList.id,
                        text: favouriteList.name,
                    }
                });
            },
            pageParam () {
                return this.$route.query.page
            }
        },
        methods: {
            ...mapActions('favourites', [
                'toggleFavourite',
            ]),
            ...mapActions({
                addToNextPrevStack: 'auction_nextprev/addToStack',
            }),
            ...mapMutations('favourites', [
                'setCurrentPage'
            ]),
            getDateTime,
            getNZDateTime,
            getJapanDiff,
            onUserChange(){
                if (this.userFilter && this.userFilter !== this.loggedInUser.id) {
                    this.$updateUrlQuery({user_id: this.userFilter})
                } else {
                    this.$updateUrlQuery({user_id: null})
                }
                this.getData()
            },
            onTagChanged(data){
                let selected = this.selectedVehicles.indexOf(data.vehicle_id);
                if (data.removed) {
                    if (data.tags_left === 0 && selected !== -1) {
                        this.selectedVehicles.splice(selected, 1);
                    }
                } else {
                    if (selected === -1) {
                        this.selectedVehicles.push(data.vehicle_id);
                    }
                }
            },
            onFavFilter(){
                this.$nextTick(() => {
                    this.$updateUrlQuery({tag_id: this.favouriteListForFilter})
                });
                this.current_page = 1;
            },
            onSortChange() {
                this.$nextTick(() => {
                    let value = this.sortByModel;
                    if (!this.sortByModel) {
                        value = 'created_at'
                    }
                    this.sort_by = this.order_options[value].field;
                    this.sort_desc = this.order_options[value].order_desc;
                    this.$updateUrlQuery({sort_by: this.sortByModel})
                    this.$nextTick(() => {
                        this.current_page = 1;
                    })
                })
            },
            onDateChange(){
                if (this.selectedAuctionDate) {
                    this.$updateUrlQuery({date: this.selectedAuctionDate})
                } else {
                    this.$updateUrlQuery({date: null})
                }
                this.getData();
            },
            getData(){
                let page = this.current_page
                this.loading = true;
                this.$nextTick( async () => {
                    try{
                        let favs_promise = this.$store.dispatch('favourites/getFavourites', {
                            favourite_list_id: this.favouriteListForFilter,
                            auction_date: this.selectedAuctionDate,
                            user_id: this.userFilter,
                            sort_by: this.sort_by,
                            sort_desc: this.sort_desc ? 1 : 0,
                            page
                        });
                        let results = await Promise.all([favs_promise, this.getfavouriteLists()])
                        let res = results[0]
                        let favs = []
                        let ids = []
                        if (res && res.data) {
                            res.data.forEach(v => {
                                ids.push(v.api_id)
                                if (v.favourites_count > 0) {
                                    favs.push(v.api_id)
                                }
                            })
                        }
                        this.vehicleIds = ids
                        this.addToNextPrevStack({ids});
                        this.selectedVehicles = favs
                        if (this.$router && this.$router.lastScrollPosition) {
                            this.$nextTick(() => {
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.$store.dispatch('auction_nextprev/checkListReturn', this.$route.query.state_key || null)
                                });
                            })
                        }
                    } catch (e) {
                        console.warn('exception in getData', e);
                        this.loading = false;
                    }
                })
            },
            objLookup(obj, key) {
                return objLookup(obj, key);
            },
            removeFavourite(vehicle_id) {
                this.$store.dispatch('favourites/removeFavourite', vehicle_id).then(success => {
                    if (success) {
                        this.$message.success('The favourite was removed.');
                    } else {
                        this.$message.error('There was a problem removing the favourite.');
                    }
                })
            },
            async getfavouriteLists() {
                try {
                    let success = await this.$store.dispatch('favourites/getFavouriteListForFavouritesPage', {user_id: this.userFilter, auction_date: this.selectedAuctionDate})
                } catch (e) {
                    return false
                    console.warn('exception in getfavouriteLists', e)
                }
                return true;
            },
            addfavouritesToList() {
                this.$store.dispatch('favouriteTags/storeManyFavouriteTagMapping', {
                    favourite_tag_id: this.selectedfavouriteList,
                    vehicle_ids: this.selectedVehicles,
                }).then(() => {
                    this.$message.success('Added to list.')
                });
            },
            displayAuctionHouse(orig_name) {
                let auctionName = '';
                let name = orig_name.replace(/[^a-zA-Z]/, ' ').replace(/\s{2,}/, ' ');
                // Auction name split in an array
                if (name.indexOf(' ') !== -1) {
                    let arrayName = name.split(' ');
                    // Compose the auction name 2 chars for the first word and 3 chars for the second word.
                    auctionName = arrayName[0].slice(0, 2) + '-' + arrayName[1].slice(0, 3)
                } else if (name.length > 2) {
                    auctionName = name.slice(0, 2);
                }
                return auctionName;
            },
            getVehicleLink(vehicle) {
                return this.$laravelRoute('vehicle-detail', {id: vehicle.api_id, state_key: window.history.state.key});
            },
            openFavouriteTagList(vehicle_id) {
                this.favListModalOpen = true;
                this.selectedVehicleId = vehicle_id;
                this.$store.dispatch('favouriteTags/maybeGetTags', {});
            },
            tagPopupModal(vehicle_id) {
                this.openFavouriteTagList(vehicle_id);
            },
            convertEquipment(item) {
                if(item) {
                    let html = item.replace(/ /g, ', ');
                    html = html.toUpperCase();
                    return html;
                }

                return '';
            },
            onChange(){
                this.$nextTick(() => {
                    if (this.order_options[this.sort_by]) {
                        this.sortByModel = this.sort_by
                    } else {
                        this.sortByModel = ''
                    }
                    this.current_page = 1
                })
            },
            getDate(data) {
                return window.moment(data).format(this.defaultMomentDateFormat())
            },
            selectVehicle(vehicle, e) {
                let selected = this.selectedVehicles.indexOf(vehicle.api_id);
                if (selected !== -1) {
                    this.selectedVehicles.splice(selected, 1);
                    this.$store.dispatch('favourites/removeFavourite', vehicle.api_id);
                } else {
                    this.selectedVehicles.push(vehicle.api_id);
                    this.$store.dispatch('favourites/addFavourite', vehicle.api_id);
                }
            },
            isFavourite(vehicle_id) {
                let is_fav = false;
                if (this.favourites) {
                    this.favourites.forEach(fav => {
                        if (fav === vehicle_id) {
                            is_fav = true;
                        }
                    });
                }
                return is_fav;
            },
            showBox(event) {
                var position = $(event.target).offset();
                var width = 650;
                var positionBox = position.left + width;

                if (positionBox > $(window).width()) {
                    this.boxLeft = true;
                } else {
                    this.boxLeft = false;
                }

            },
            vehicleClasses(vehicle) {
                let classes = [];
                if (this.selectedVehicles.indexOf(vehicle.api_id) !== -1) {
                    classes.push('selected');
                }
                if (vehicle.hasOwnProperty('viewed') && vehicle.viewed) {
                    classes.push('viewed');
                }
                return classes.join(' ');
            },
            numberWithCommas(val) {
                return numberWithCommas(val);
            },
            sendRecommend() {
                //this.recommendModelOpen = true
                window.location.href = this.$laravelRouter('favourite-list.index') + `?tag_id=${this.favouriteListForFilter}`
            }
        },
        watch: {
            pageParam (value) {
                if (value) {
                    this.$store.commit('favourites/setCurrentPage', value)
                    this.getData()
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Favourites/FavouritesPage.vue